module.exports = __webpack_public_path__ + "static/media/icon-pressure.a24b3bec.svg";